import React, { ReactNode } from 'react';
import { NavLink, To } from 'react-router-dom';
import withTheme from '../../hocs/withTheme';
import './TabbedNavigation.css';

function Link({ children, to, ...rest } : {children: ReactNode; to: To}) {
    return (
        <NavLink
            {...rest}
            className={({isActive}) => `Tabbed-navigation__link${isActive ? ' active' : ''}`}
            to={to}
        >
            {children}
        </NavLink>
    );
}

export default withTheme(Link);
